import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main'
import Login from '../views/Login.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    meta: { auth: true }, // так как Main пытается брать юзера и в зависимости от этого рисует кнопку выход
    component: Main
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/audit',
    meta: { auth: true, title: 'Проверка точки' },
    component: () => import('../views/Audit.vue')
  },
  {
    path: '/qr',
    meta: { auth: true },
    component: () => import('../views/QRReader.vue')
  },
  {
    path: '/error',
    meta: { title: 'Ошибка' },
    component: () => import('../views/Error.vue')
  },
  // TODO: 404 page
  {
    path: '*',
    meta: { title: '404 - Нет такой страницы' },
    component: () => import('../views/Error.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from) => {
  store.dispatch('setAppTitle', to.meta?.title ? to.meta.title : 'TradeWeb')
})

router.beforeEach((to, from, next) => {
  // если идут на логин или ошибку или другую паблик-страницу, то пусть идут
  const authRequired = to.matched.some(x => x.meta.auth)
  if (!authRequired) {
    next()
    return
  }

  // если токен пропал -> рестор из хранилища
  if (!store.state.auth.token) {
    store.dispatch('auth/restoreToken')
  }
  // в хранилище токена нет - логин
  if (!store.state.auth.token) {
    next('/login')
    return
  }

  // если пользователь уже есть - роутим его
  if (store.state.auth.user) {
    next()
    return
  }
  // нет пользователя - загружаем его данные: login в данном случае
  store.dispatch('auth/setUser')
    .then(() => {
      // всё равно роутим
      next()
    })
    .catch(() => {
      // если не смогли загрузить пользователя - логин
      next('/login')
    })
})

export default router
